import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { browseTrackingSave } from '~/server/common'
import routerList from '~/common/routers/routerList'
import { useCityInfoStore } from '~/stores/useCityInfo'

export function usePageTimeTracker() {
  const route = useRoute()
  const { city } = useCityInfoStore()
  const startTime = ref<number | null>(null)
  const endTime = ref<number | null>(null)
  // 当前页面名称
  const { name, params } = route
  const { floorId, houseModelId, floorHouseId } = params
  const tempRoute = routerList.find(item => item.name === name)
  const { businessDataId = 1 } = tempRoute || {}
  const userStore = useUserInfoStore()
  const { userId } = userStore?.userInfo ?? {}
  const uuid = ref('')
  const trackingLogId = ref(0)
  const nuxtApp = useNuxtApp()

  // 页面加载时记录起始时间=> 获取设备唯一标识=> 记录浏览日志
  onMounted(async () => {
    startTime.value = Date.now()
    uuid.value = nuxtApp.$getUuid()
    const params = {
      browseEndTime: 0,
      browseStartTime: startTime.value,
      businessDataId,
      businessId: floorId,
      cityId: city,
      equipmentBrowseUuid: uuid.value,
      numberId: floorHouseId || houseModelId || floorId,
      pageName: document.title,
      pageUrl: window.location.origin + route.path,
      portTypeId: 1,
      referrerDomain: window.location.origin,
      referrerUrl: route.path,
      sectionId: 1,
      trackingLogId: 0,
      userId: userId || 0,
    }
    const res = await browseTrackingSave(params)
    const { code, dataBody } = res
    if (code === 0) {
      trackingLogId.value = dataBody
    }
    window.addEventListener('beforeunload', () => {
      endTime.value = Date.now()
      browseTrackingSave(Object.assign({}, params, {
        browseEndTime: endTime.value,
        trackingLogId: trackingLogId.value,
      }))
    })
  })
}
